import { render, staticRenderFns } from "./scholarAnalysis.vue?vue&type=template&id=55a1142c&scoped=true&"
import script from "./scholarAnalysis.vue?vue&type=script&lang=js&"
export * from "./scholarAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./scholarAnalysis.vue?vue&type=style&index=0&id=55a1142c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1142c",
  null
  
)

export default component.exports